import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../common/Button';
import './PatientSectionHeader.css';

const PatientSectionHeader = ({ 
  patientId, 
  patientName, 
  sectionTitle, 
  actionButton,
  onBackClick 
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(`/patients/${patientId}`);
    }
  };

  return (
    <div className="patient-section-header">
      <div className="patient-section-header-left">
        <Button 
          variant="outline" 
          icon="fas fa-arrow-left" 
          onClick={handleBackClick}
        >
          Regresar
        </Button>
        <div className="patient-section-title">
          <h1>{sectionTitle}</h1>
          <p>{patientName || `Paciente: ${patientId}`}</p>
        </div>
      </div>
      {actionButton && (
        <div className="patient-section-header-actions">
          {actionButton}
        </div>
      )}
    </div>
  );
};

export default PatientSectionHeader;
